import { useKeepAliveStore } from '@/pinia/keep-alive'
import { useUserStore } from '@/pinia/user'
import { isWhiteList } from '@/router/whitelist'
import { getToken } from '@/utils/cache/cookies'
import { useArticleStore } from '@/pinia/article'
import { queryArticle } from '@/service/api/createCenter.js'
import { bridge } from '@/common/bridge/methods'
import { BRIDGE_METHODS } from '@/common/bridge/constants'
import service from '@/config'
import { productExists } from '@/service/api/product'
import { NavigateToWebview } from '@/utils/webviewNavigation'
import { isInWeChatMiniProgram } from '@/utils/tool'
import { compareVersion } from '@/utils/compareVersion'

const LOGIN_PATH = '/login'
// 在app环境下才会显示nav
const isApp = window.flutter_inappwebview ? true : false

export function registerNavigationGuard(router) {
  // 全局前置守卫
  router.beforeEach(async (to, _from) => {
    if (to.path === '/creation/detail' || to.path === '/shareDetail') {
      // const articleStore = useArticleStore()
      // let res = await queryArticle(to.query.id)
      // to.meta.title = res.title || '图文详情'
      // articleStore.setArticleDetail(res)
    }

    // 如果跳转地址包含getLocation()前缀，添加用户参数
    const locationUrl = service?.getLocation()
    if (to.fullPath.includes(locationUrl) || to.path.includes(locationUrl)) {
      const mobile = sessionStorage.getItem('mobile') || ''
      const loginToken = sessionStorage.getItem('loginToken') || ''
      const loginId = sessionStorage.getItem('loginId') || ''
      const memberId = sessionStorage.getItem('memberId') || ''

      // 检查参数是否存在或为空值，如果没带或者为空就重新赋值
      if (mobile && (!to.query.mobile || to.query.mobile === '')) {
        to.query.mobile = mobile
      }
      if (loginToken && (!to.query.loginToken || to.query.loginToken === '')) {
        to.query.loginToken = loginToken
      }
      if (loginId && (!to.query.loginId || to.query.loginId === '')) {
        to.query.loginId = loginId
      }
      if (memberId && (!to.query.memberId || to.query.memberId === '')) {
        to.query.memberId = memberId
      }
      // 构建处理后的完整URL用于调试
      const baseUrl = to.path
      const queryParams = new URLSearchParams(to.query).toString()
      const fullUrl = queryParams ? `${baseUrl}?${queryParams}` : baseUrl

      alert(
        `路由守卫处理后的跳转链接:\n${fullUrl}\n\n参数详情:\nmobile: ${to.query.mobile || '无'}\nloginToken: ${to.query.loginToken || '无'}\nloginId: ${to.query.loginId || '无'}\nmemberId: ${to.query.memberId || '无'}`
      )
      return true
    }

    // 处理产品详情页跳转逻辑
    if (to.path === '/product' && to.query.id) {
      // 检查是否需要跳转到其他项目
      try {
        const isKlook = await productExists({
          terminalCode: sessionStorage.getItem('terminalCode'),
          searchKeyword: to.query.id
        })
        
        if (isKlook?.subSource === 1) {
          let type = 'push'
          let hasHistory = true
          
          if (isApp) {
            try {
              const version = await bridge.invokeSync(BRIDGE_METHODS.GET_VERSION)
              const versionInfo = version?.result?.data || ''
              const isNewVersion = compareVersion(versionInfo.version, '6.0.13') < 0 ? false : true
              type = isNewVersion ? 'replace' : 'push'
              hasHistory = isNewVersion ? true : false
            } catch (error) {
              console.error('获取版本信息失败:', error)
            }
          } else if (isInWeChatMiniProgram()) {
            hasHistory = false
          }
          
          // 根据产品类型跳转到不同的页面
          if (isKlook.type === 2) {
            NavigateToWebview({
              url: `/ticket/index?id=${isKlook.serviceId}`,
              projectName: 'client',
              type,
              hasHistory,
            })
          } else {
            NavigateToWebview({
              url: `/productIndex/index?id=${isKlook.serviceId}`,
              projectName: 'client',
              type,
              hasHistory,
            })
          }
          
          // 阻止路由继续，因为已经跳转到其他项目
          return false
        }
      } catch (error) {
        console.error('检查产品跳转逻辑失败:', error)
        // 如果检查失败，继续正常路由流程
      }
    }
    if (to.path === '/visaList' && isApp) {
      bridge.invoke(BRIDGE_METHODS.FIRST_CONTENTFUL_PAINT, { controlLoading: true })
    }
    if (to.path === '/orderlist' && isApp) {
      bridge.invoke(BRIDGE_METHODS.FIRST_CONTENTFUL_PAINT, { controlLoading: true })
    }
    if (to.path === '/myComment' && isApp) {
      bridge.invoke(BRIDGE_METHODS.FIRST_CONTENTFUL_PAINT, { controlLoading: true })
    }
    if (to.path === '/myother/information' && isApp) {
      bridge.invoke(BRIDGE_METHODS.FIRST_CONTENTFUL_PAINT, { controlLoading: true })
    }
    if (to.path === '/nearbyStores' && isApp) {
      bridge.invoke(BRIDGE_METHODS.FIRST_CONTENTFUL_PAINT, { controlLoading: true })
    }

    const userStore = useUserStore()
    // 如果没有登录
    // if (!getToken()) {
    //   // 如果在免登录的白名单中，则直接进入
    //   if (isWhiteList(to)) return true
    //   // 其他没有访问权限的页面将被重定向到登录页面
    //   return LOGIN_PATH
    // }

    document.title = to.meta?.title || ''
    // 如果已经登录，并准备进入 Login 页面，则重定向到主页
    if (to.path === LOGIN_PATH) return '/'
    // 判断有无该页面权限
    if (to.meta.roles ? userStore.roles.some(role => to.meta.roles.includes(role)) : true)
      return true
    // 无权限则进入 403 页面
    return '/403'
  })
  // 全局后置钩子
  router.afterEach(to => {
    const keepAliveStore = useKeepAliveStore()
    // 清除所有路由缓存
    if (to.path === LOGIN_PATH) keepAliveStore.delAllCachedRoutes()
    // 添加路由缓存
    keepAliveStore.addCachedRoute(to)
  })
}
